import React from 'react'
import { Helmet } from 'react-helmet-async'
import metaConfig from './MetaConfig'

interface MetaDataProps {
  page: string;
  param?: string | object;
}

interface MetaConfigResult {
  title_tag: string;
  en_page_url: string;
  es_page_url: string;
  meta_title: string;
  meta_description: string;
  meta_og_type: string;
  meta_og_url: string;
  meta_og_title: string;
  meta_og_description: string;
  meta_og_image: string;
  meta_tw_card: string;
  meta_tw_url: string;
  meta_tw_title: string;
  meta_tw_description: string;
  meta_tw_image: string;
}

const MetaData: React.FC<MetaDataProps> = ({ page, param }) => {
  const meta: MetaConfigResult = metaConfig(page, param)

  return (
    <Helmet>
      <title>{meta.title_tag}</title>
      <link rel="canonical" hrefLang="en" key="en" href={meta.en_page_url} />
      <link rel="alternate" hrefLang="es" key="es" href={meta.es_page_url} />
      <meta name="title" content={meta.meta_title}></meta>
      <meta name="description" content={meta.meta_description}></meta>

      {/* Open Graph tags */}
      <meta property="og:type" content={meta.meta_og_type}></meta>
      <meta property="og:site_name" content="Coinigy"></meta>
      <meta property="og:url" content={meta.meta_og_url}></meta>
      <meta property="og:title" content={meta.meta_og_title}></meta>
      <meta property="og:description" content={meta.meta_og_description}></meta>
      <meta property="og:image" content={meta.meta_og_image}></meta>
      <meta property="og:image:width" content="1200"></meta>
      <meta property="og:image:height" content="630"></meta>
      <meta property="og:image:alt" content={meta.meta_og_title}></meta>

      {/* Twitter Card tags */}
      <meta name="twitter:card" content={meta.meta_tw_card}></meta>
      <meta name="twitter:site" content="@coinigy"></meta>
      <meta name="twitter:url" content={meta.meta_tw_url}></meta>
      <meta name="twitter:title" content={meta.meta_tw_title}></meta>
      <meta name="twitter:description" content={meta.meta_tw_description}></meta>
      <meta name="twitter:image" content={meta.meta_tw_image}></meta>
    </Helmet>
  )
}

export default MetaData 